import {
    Button,
    Chip,
    Typography
} from "@mui/material";

import { t, Trans } from "@lingui/macro";

import { Link } from "react-router-dom";

import { renderProgress } from "components/filledProgressBar/filledProgressBar";

import {getMatchStatus} from 'components/commons/asset-chip-props'



const defaultColumnDefinition: any = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
    sortable: false
}
const getTopBrandTableColumns = (): any => {
    return [
        {
            ...defaultColumnDefinition,
            field: "logo",
            headerName: "",
            width: 100,
            renderCell: (params: { row: any }) => {
                return <img src={params.row.brand.logo} alt="logo" width={50} style={{ borderRadius: 30 }} />
            }
        },
        {
            ...defaultColumnDefinition,
            field: "name",
            headerName: t({
                id: "map-table.brand",
                message: "Brand",
                comment: "in top brand table, brand name",
            }),
            flex: 1,
            renderCell: (params: { row: any }) => {
                return <Typography>{params.row.brand.name}</Typography>
            }
        },
        {
            ...defaultColumnDefinition,
            field: "locality",
            headerName: t({
                id: "top-brand-table.locality",
                message: "Località",
                comment: "in top brand table, locality",
            }),
            flex: 2,
            renderCell: (params: { row: any }) => {
                return <Typography>{params.row.asset.address}</Typography>
            }
        },
        {
            ...defaultColumnDefinition,
            field: "propertyType",
            headerName: t({
                id: "top-brand-table.property-type",
                message: "Tipo proprietà",
                comment: "in top brand table, property type",
            }),
            flex: 1,
            renderCell: (params: { row: any }) => {
                return <Typography>
                    <Trans id={`enums.asset-types.${params.row.asset.characteristics.type}`}>

                    </Trans>
                </Typography>
            }
        },
        {
            ...defaultColumnDefinition,
            field: "dimension",
            headerName: t({
                id: "top-brand-table.dimension",
                message: "Dimensione",
                comment: "in top brand table, dimension",
            }),
            flex: 0.5,
            renderCell: (params: { row: any }) => {
                return <Typography>{params.row.asset.characteristics.gla}</Typography>
            }
        },
        {
            ...defaultColumnDefinition,
            field: "state",
            headerName: t({
                id: "top-brand-table.state",
                message: "Stato",
                comment: "in top brand table, state",
            }),
            flex: 0.75,
            renderCell: (params: any) => {
                return <Chip {...getMatchStatus(params.row.status)} />
            }
        },
        {
            ...defaultColumnDefinition,
            field: "affinity",
            headerName: t({
                id: "top-brand-table.affinity",
                message: "Compatibilità",
                comment: "in top brand table, affinity",
            }),
            flex: 1,
            renderCell: (params: {row: any}) => {
                return (
                    renderProgress(params.row.compatibility)
                )
            }
        },
        {
            ...defaultColumnDefinition,
            field: "details",
            width: 150,
            renderCell: (params: { row: any }) => {
                return (
                    <Link key="brandProfile" to={`/match/${params.row.id}`}>
                        <Button
                            variant="contained"
                            disableElevation
                            sx={{
                                textTransform: 'none',
                                backgroundColor: 'secondary.main',
                                color: 'white',
                            }}>
                            <Typography sx={{fontSize: "0.7em",}}>
                                <Trans id="compatible-table.view-details">
                                    Vedi dettagli
                                </Trans>
                            </Typography>
                        </Button>
                    </Link>
                )
            },
        },
    ]
}

export default getTopBrandTableColumns
